"use client";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { BankTransfer } from "@/lib/SystemIcons";
import { Caption, Paragraph, Title } from "@/components/ui/typography";
import { Copy, X, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import useOrders from "@/app/hooks/useOrders";
import { useState } from "react";

export default function ViewWireDetails({ className, variant = "md" }) {
  const label = [
    { label: "Bank name", key: "bank_name" },
    { label: "Bank address", key: "bank_address" },
    {
      label: "Benificiary name",
      key: "beneficiary_name",
    },
    { label: "Routing number", key: "routing_no" },
    { label: "Account number", key: "account_no" },
    { label: "SWIFT Code", key: "swift_code" },
  ];
  const { adminAccountDetails } = useOrders();
  const [copyClicked, setCopyClicked] = useState(false);
  const [textToCopy, setTextToCopy] = useState("");

  const handleCopyText = (text) => {
    navigator.clipboard.writeText(text);
    setTextToCopy(text);
    setCopyClicked(true);
    setTimeout(() => {
      setCopyClicked(false);
    }, 2000);
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger>
        <div
          className={` flex items-start justify-center gap-2 outline outline-1 outline-midnightIndigo-200 rounded px-2 py-1 hover:outline-midnightIndigo-400  ${className}`}
        >
          <BankTransfer className="h-5 w-5" />
          {variant === "lg" ? (
            <span className="text-[15px] wireless-Medium mt-[2px] ">
              View Wire Details
            </span>
          ) : (
            <>
              <span className="text-[15px] wireless-Medium hidden md:block mt-[2px] ">
                View Wire Details
              </span>
              <span className="text-[15px] wireless-Medium block md:hidden mt-[2px]">
                Wire
              </span>
            </>
          )}
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent className="w-[300px] md:w-[520px] rounded ">
        <AlertDialogHeader
          className={"flex flex-row justify-between items-center border-b pb-4"}
        >
          <Title size="sm">Wire transfer details</Title>{" "}
          <AlertDialogCancel className="!h-[30px] !w-[30px] border-0">
            <X />
          </AlertDialogCancel>
        </AlertDialogHeader>

        <div>
          {label.map((item) => (
            <div key={item.key} className="flex flex-col justify-between mb-6">
              <Caption>{item.label}</Caption>
              <div className="flex items-center justify-between">
                <Paragraph>
                  {adminAccountDetails?.data &&
                    adminAccountDetails?.data[item.key]}
                </Paragraph>
                <Button
                  variant="icon"
                  className="!h-[25px] !w-[25px] border-0 "
                >
                  {copyClicked &&
                  textToCopy === adminAccountDetails?.data[item.key] ? (
                    <Check />
                  ) : (
                    <Copy
                      onClick={() =>
                        handleCopyText(adminAccountDetails?.data[item.key])
                      }
                    />
                  )}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
